export default "/images/7fe3034bbc378609ecb87df8a2d82b19.avif";